import { createGetEndpoint } from '@sonar-software/sonar-http';

export type GetJiraStatusResponse = {
	id: string;
	name: string;
};

export const getJiraStatuses = createGetEndpoint<null, Array<GetJiraStatusResponse>>(() => '/api/v3/jira/statuses');
